/**
 * Sets a cookie with the given name and value.
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {number} [days] - Expiration days (0 for session cookie)
 * @returns {boolean} True if cookie was set successfully, false otherwise
 */
export const setCookie = (name: string, value: string, days = 30): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    const encodedValue = encodeURIComponent(value)
    let cookieString = `${name}=${encodedValue};path=/`

    if (days > 0) {
      const d = new Date()
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
      cookieString += `;expires=${d.toUTCString()}`
    } else if (days === 0) {
      // Session cookie - no expires attribute
      cookieString += ';expires='
    }

    cookieString += ';SameSite=Lax'

    if (window.location.protocol === 'https:') {
      cookieString += ';Secure'
    }

    document.cookie = cookieString

    return true
  } catch (error) {
    console.error('Failed to set cookie:', error)

    return false
  }
}
